import _extends from "/app/node_modules/babel-runtime/helpers/extends";
import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ListItem from "~/components/collaborators/slide-item";
import alertModal from "~/components/collaborators/alert-modal";
import editChannelModal from "~/components/collaborators/edit-channel";
import newTeamModal from "~/components/collaborators/new-team-modal";
import newSellerModal from "~/components/collaborators/new-seller-modal";
import chargeSellerModal from "~/components/collaborators/new-charge-seller-modal";
import errorFileModal from "~/components/collaborators/error-modal";
import loader from "~/components/modals/loader";
import { mapState, mapActions } from "vuex";
import { NoContentError } from "~/abstractions/errors";

export default {
    fetch: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
            var store = _ref.store,
                app = _ref.app,
                params = _ref.params,
                redirect = _ref.redirect;
            var value;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            value = Number(params.id);
                            _context.next = 4;
                            return store.dispatch("channel/loadListOfTeamsForAdmin", value);

                        case 4:
                            _context.next = 6;
                            return store.dispatch("channel/findChannelForEdit", value);

                        case 6:
                            _context.next = 11;
                            break;

                        case 8:
                            _context.prev = 8;
                            _context.t0 = _context["catch"](0);

                            if (_context.t0 instanceof NoContentError) redirect("/bosses");else app.$controlMessage(_context.t0);

                        case 11:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, this, [[0, 8]]);
        }));

        function fetch(_x) {
            return _ref2.apply(this, arguments);
        }

        return fetch;
    }(),
    asyncData: function asyncData(_ref3) {
        var app = _ref3.app,
            redirect = _ref3.redirect;

        if (app.$isBoss()) {
            return redirect("/channels");
        } else if (app.$isSupervisor()) {
            return redirect("/my-team");
        }
        return null;
    },

    components: {
        ListItem: ListItem,
        alertModal: alertModal,
        editChannelModal: editChannelModal,
        newTeamModal: newTeamModal,
        newSellerModal: newSellerModal,
        loader: loader,
        chargeSellerModal: chargeSellerModal,
        errorFileModal: errorFileModal
    },
    data: function data() {
        var _$store$state$channel = this.$store.state.channel.dataChannel,
            Name = _$store$state$channel.Name,
            IsActive = _$store$state$channel.IsActive,
            IdChannel = _$store$state$channel.IdChannel;

        var status = IsActive == true ? "Canal Activo" : "Canal Inactivo";
        return {
            titlePrincipal: Name,
            typeState: status,
            conditionalNotContent: false,
            messageNotContent: "No hay Equipos asignados a este Canal",
            buttonAddColaborator: true,
            collaboratorsTitle: "Equipos",
            typeOfTable: "DetailTeam",
            buttonNewCollaborator: "Nuevo equipo",
            buttonNewChargeSeller: "Carga Masiva",
            idTeam: IdChannel,
            loaderText: "Procesando información",
            statusChannel: IsActive,
            teamIsActive: true,
            itemsActive: []
        };
    },

    methods: {
        registerFile: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(file) {
                var _this = this;

                var read, response, id;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return this.$store.dispatch("collaborators/teams/readChargeSeller", file);

                            case 3:
                                read = _context2.sent;

                                this.$refs.loaderModal.showLoader();
                                _context2.next = 7;
                                return this.$store.dispatch("collaborators/teams/chargeSeller", read);

                            case 7:
                                response = _context2.sent;

                                if (response.length) {
                                    _context2.next = 12;
                                    break;
                                }

                                this.$refs.alertModal.openModal("Archivo cargado con éxito");
                                _context2.next = 15;
                                break;

                            case 12:
                                _context2.next = 14;
                                return this.$store.dispatch("collaborators/teams/sendMailErrorsCharge", response);

                            case 14:
                                this.$refs.errorFileModal.openModal({
                                    title: "Error en el archivo",
                                    message: "El archivo tiene errores. Revise su correo para corregirlos."
                                });

                            case 15:
                                id = Number(this.$route.params.id);
                                _context2.next = 18;
                                return this.$store.dispatch("channel/loadListOfTeamsForAdmin", id);

                            case 18:
                                _context2.next = 20;
                                return this.$store.dispatch("channel/findChannelForEdit", id);

                            case 20:
                                this.itemsActive.forEach(function (item) {
                                    return _this.updateShowChannels(item);
                                });
                                _context2.next = 26;
                                break;

                            case 23:
                                _context2.prev = 23;
                                _context2.t0 = _context2["catch"](0);

                                this.$controlMessage(_context2.t0);

                            case 26:

                                this.$refs.chargeSellerModal.close();
                                this.$refs.loaderModal.closeLoader();

                            case 28:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this, [[0, 23]]);
            }));

            function registerFile(_x2) {
                return _ref4.apply(this, arguments);
            }

            return registerFile;
        }(),
        prevPage: function prevPage() {
            this.$router.push("/bosses/");
        },
        openEdit: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                this.$refs.editChannelModal.idChannel = this.idTeam;
                                this.$refs.editChannelModal.editThisChannel();

                            case 2:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function openEdit() {
                return _ref5.apply(this, arguments);
            }

            return openEdit;
        }(),
        openNewItem: function openNewItem() {
            this.$refs.newTeamModal.channelIsActive = this.statusChannel;
            this.$store.commit("team/setIdChannel", this.idTeam);
            this.$refs.newTeamModal.value = this.idTeam;
            this.$refs.newTeamModal.addModalConfig();
        },
        openNewItem2: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                this.$store.commit("team/setIdChannel", this.idTeam);
                                this.$refs.chargeSellerModal.open();

                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function openNewItem2() {
                return _ref6.apply(this, arguments);
            }

            return openNewItem2;
        }(),
        addNewItem: function addNewItem(val) {
            this.$refs.newSellerModal.teamIsActive = val.active;
            var conditional = val.channels == "0" ? true : false;
            this.$refs.newSellerModal.addNewSeller();
            this.$refs.newSellerModal.idUser = val.value;
            this.$refs.newSellerModal.conditionalIsSupervisor = conditional;
        },
        editThisChannel: function editThisChannel(val) {
            this.$refs.newTeamModal.channelIsActive = this.statusChannel;
            this.$refs.newTeamModal.isHaveNotSellers = val.channels == "0" ? true : false;
            this.$refs.newTeamModal.idTeam = val.value;
            this.$refs.newTeamModal.editModalConfig();
            //this.upDateTeam()
        },
        editTeamModal: function editTeamModal(val) {
            this.$refs.newTeamModal.editModalConfig();
        },
        completeForm: function completeForm() {
            var _this2 = this;

            this.$refs.alertModal.openModal();
            if (this.list) {
                this.list.forEach(function (item, i) {
                    _this2.$refs.listItem[i].showTable = false;
                });
            }
        },
        toTeamsTable: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(val) {
                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                this.titlePrincipal = val.val.name;
                                this.typeState = val.val.active == true ? "Equipo Activo" : "Equipo Inactivo";
                                this.statusChannel = val.val.active;

                            case 3:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function toTeamsTable(_x3) {
                return _ref7.apply(this, arguments);
            }

            return toTeamsTable;
        }(),
        upDateTeam: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                var response;
                return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.$store.dispatch("channel/loadListOfTeamsForAdmin", this.idTeam);

                            case 2:
                                response = _context6.sent;
                                return _context6.abrupt("return", response);

                            case 4:
                            case "end":
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function upDateTeam() {
                return _ref8.apply(this, arguments);
            }

            return upDateTeam;
        }(),
        showChannels: function showChannels(value) {
            this.itemsActive.push(value);
            this.updateShowChannels(value);
        },
        closeChannels: function closeChannels(value) {
            this.itemsActive = this.itemsActive.filter(function (item) {
                return item !== value;
            });
        },
        updateShowChannels: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(value) {
                return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.$store.dispatch("boss/loadChannels", value);

                            case 2:

                                this.$refs.newTeamModal.idTeam = value;

                                if (!(this.collaboratorsTitle === "Equipos")) {
                                    _context7.next = 7;
                                    break;
                                }

                                _context7.next = 6;
                                return this.$store.dispatch("channel/loadItemsInListOfTeamsForAdmin", value);

                            case 6:
                                this.responseofSeller = value;

                            case 7:
                            case "end":
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function updateShowChannels(_x4) {
                return _ref9.apply(this, arguments);
            }

            return updateShowChannels;
        }(),
        editSellerTable: function editSellerTable(val) {
            this.$refs.loaderModal.showLoader();
            this.$router.push({
                path: "/bosses/channel/" + this.idTeam + "/seller/" + val.item.value,
                query: { teamStatus: val.teamIsActive }
            });
        },
        isContent: function isContent() {
            if (this.list.length == 0) {
                this.conditionalNotContent = true;
                this.$refs.editChannelModal.isHaveNotTeams = true;
            } else {
                this.conditionalNotContent = false;
                this.$refs.editChannelModal.isHaveNotTeams = false;
            }
        },
        notShowContent: function notShowContent() {
            this.conditionalNotContent = false;
        }
    },
    computed: _extends({}, mapState({
        list: function list(state) {
            return state.channel.teamForAdmin;
        }
    })),
    mounted: function mounted() {
        var _this3 = this;

        this.$nextTick(function () {
            return _this3.isContent();
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/bosses/channel/_id/index.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/bosses/channel/_id/index.vue
// module chunks = 4